import React from 'react';
import { Form, Formik } from 'formik';

import AgModalWindow from '@/components/common/ModalWindow/AgModalWindow';
import Textarea from '@/components/common/Textarea/Textarea';
import ActionButtonsWrapper from '@/components/common/ModalWindow/ActionButtonsWrapper/ActionButtonsWrapper';
import Button, { ButtonStyleType } from '@/components/common/Button/Button';
import { Fields, validationSchema } from './validationSchema';
import { ValidationAlert } from '@/components/common/ValidationAlert/ValidationAlert';

interface IAddNoteModalProps {
  onClose: () => void;
  onSave: (text: string) => void;
}

export default function AddNoteModal({ onClose, onSave }: IAddNoteModalProps) {
  return (
    <AgModalWindow
      isOpen={true}
      onClose={onClose}
      title="Add Note"
      contentStyle={{ width: 450 }}
    >
      <Formik<Fields>
        initialValues={{ text: '' }}
        validationSchema={validationSchema}
        validateOnMount={true}
        onSubmit={(values) => onSave(values.text.trim())}
      >
        {({ values, errors, touched, setFieldValue, setFieldTouched, isValid }) => (
          <Form>
            <ValidationAlert
              isVisible={Boolean(touched.text && errors.text)}
              text={errors.text}
            >
              <Textarea
                value={values.text}
                placeholder="Enter note here"
                onChange={(e) => {
                  setFieldValue('text', e.target.value);
                  setFieldTouched('text', true, false);
                }}
              />
            </ValidationAlert>

            <ActionButtonsWrapper
              showDivider={false}
              leftButton={(
                <Button
                  buttonStyleType={ButtonStyleType.SECONDARY}
                  onClick={() => {
                    onClose();
                  }}
                >
                  Cancel
                </Button>
              )}
              rightButton={(
                <Button
                  disabled={!isValid}
                  type="submit"
                  buttonStyleType={ButtonStyleType.PRIMARY}
                >
                  Save
                </Button>
              )}
            />
          </Form>
        )}
      </Formik>
    </AgModalWindow>

  );
}
